import React from 'react';

interface IAlignRightIconProps {
  style?: any;
  fill?: string;
}

export const AlignRightIcon:React.FC<IAlignRightIconProps> = (props: IAlignRightIconProps) => {
  return (
    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.7006 0H1.24641C0.556906 0 0 0.556906 0 1.24641C0 1.93591 0.556906 2.49282 1.24641 2.49282H22.7536C23.4431 2.49282 24 1.93591 24 1.24641C24 0.556906 23.4431 0 22.7006 0Z" fill={props.fill ? props.fill : "#424C57"}/>
      <path d="M22.2221 8.72329C22.9116 8.72329 23.4685 8.16638 23.4685 7.47688C23.4685 6.78738 22.9116 6.23047 22.2221 6.23047H8.24641C7.55691 6.23047 7 6.78738 7 7.47688C7 8.16638 7.55691 8.72329 8.24641 8.72329H22.2221Z" fill={props.fill ? props.fill : "#424C57"}/>
      <path d="M22.7006 12.4883H1.24641C0.556906 12.4883 0 13.0452 0 13.7347C0 14.4242 0.556906 14.9811 1.24641 14.9811H22.7536C23.4431 14.9811 24 14.4242 24 13.7347C24 13.0452 23.4431 12.4883 22.7006 12.4883Z" fill={props.fill ? props.fill : "#424C57"}/>
      <path d="M22.2221 18.7227H8.24641C7.55691 18.7227 7 19.2796 7 19.9691C7 20.6586 7.55691 21.2155 8.24641 21.2155H22.2751C22.9646 21.2155 23.5215 20.6586 23.5215 19.9691C23.5215 19.2796 22.9646 18.7227 22.2221 18.7227Z" fill={props.fill ? props.fill : "#424C57"}/>
    </svg>
  )
}